import{isHex as t}from"./isHex.js";function e(e){return t(e,{strict:!1})?Math.ceil((e.length-2)/2):e.length}export{e as size};
